import React from 'react';
import MaterialTable from 'material-table';
import EditIcon from '@material-ui/icons/Edit';
import PropTypes from 'prop-types';

const propTypes = {
  title: PropTypes.any,
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  onEdit: PropTypes.func.isRequired,
};

const defaultProps = {
  title: null,
  data: [],
  columns: [],
  onEdit: () => {
  }
};

function AnalyticsDataTable({
  title,
  data,
  columns,
  onEdit
}) {
  return (
    <MaterialTable
      title={title}
      columns={columns}
      options={{
        rowStyle: {
          textAlign: 'left',
          verticalAlign: 'top',
        },
        search: false,
        actionsColumnIndex: 0,
        pageSize: 10
      }}
      actions={[
        {
          icon: () => (<EditIcon/>),
          tooltip: 'Edit',
          iconProps: { color: 'primary' },
          onClick: (event, rowData) => onEdit(rowData)
        },
      ]}
      data={data}
    />
  );
}

AnalyticsDataTable.propTypes = propTypes;
AnalyticsDataTable.defaultProps = defaultProps;
export default AnalyticsDataTable;



// WEBPACK FOOTER //
// ./src/components/AnalyticsDataTable/index.jsx